import _ from "lodash";
import moment from "moment";

export default {
    methods: {
        saveOrder(event) {
            if (!(this.disableDefaultFooter && this.disablePagination)) return;
            const movedItem = this.data.splice(event.oldIndex, 1)[0];
            this.data.splice(event.newIndex, 0, movedItem);
            let _data = this.data.map((item, key) => {
                let i = Number(key) + 1;
                return {
                    ...item,
                    ordering: i
                }
            });
            this.handleItem(this.actions.sorted, {items: _data});
        },
        openPopUp() {
            this.showPopup = true;
        },
        closePopupHandler() {
            this.showPopup = false;
            this.showFilesPopup = false;
            this.showLinkPopup = false;
            this.showManualPaymentPopup = false;
            this.showManualMergedPaymentPopup = false;
            this.showEmailTimeliner = false;
            this.showMergedLinkPopup = false;

            setTimeout(() => {
                this.editedItem = {};
                this.editedIndex = -1;
            }, 300);
        },
        async deleteItem(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showDeleteConfirm = true;
                return;
            }
            this.showDeleteConfirm = false;
            const id = item.id;
            this.handleItem(this.actions.remove, {id});
        },
        async softDeleteHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showSoftDeleteConfirm = true;
                return;
            }
            this.showSoftDeleteConfirm = false;
            const id = item.id;
            this.handleItem(this.actions.softDelete, {id});
        },
        editItem(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showPopup = true;
        },
        viewEmailDetails(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEmailTimeliner = true;
        },
        linkHandler(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showLinkPopup = true;
        },
        mergedLinkHandler(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showMergedLinkPopup = true;
        },
        fileHandler(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showFilesPopup = true;
        },
        getPagingData() {
            return {
                ...this.pagination,
                rowsPerPage: this.pagination.itemsPerPage,
                sortBy: this.pagination.sortBy[0],
                descending: this.pagination.sortDesc[0],
                s: '',
                startDate: this.startDate,
                endDate: this.endDate,
                user: this.searchUser,
                paymentStatus: this.paymentStatus,
                deleteStatus: this.deleteStatus,
                payMethod: this.payMethod,
                email: this.searchEmail,
                param1: this.param1,
                clientType: this.clientType
            };
        },
        async saveItemHandler(item) {
            if (this.editedIndex > -1) {
                this.handleItem(this.actions.update, item);
            } else {
                this.handleItem(this.actions.create, item);
            }
        },
        handleItem(actionHooks, item, isLoaded = true) {
            this.$store.dispatch(actionHooks, item)
                .then((response) => {
                    const {data} = response;
                    this.isNewsletterBtnLoading = false
                    this.setSnackBar({text: data.message, type: 'info'})
                })
                .catch((error) => {
                    const errors = error.response.data.errors;
                    this.isNewsletterBtnLoading = false
                    if (typeof errors !== "undefined" && errors.email && errors.email[0]) {
                        this.setSnackBar({text: errors.email[0], type: 'error'});
                    } else if (typeof errors !== "undefined" && errors.name[0]) {
                        this.setSnackBar({text: errors.name[0], type: 'error'});
                    } else if (typeof errors !== "undefined" && errors.message[0]) {
                        this.setSnackBar({text: errors.message[0], type: 'error'});
                    } else if (typeof error.response.data.message !== "undefined") {
                        this.setSnackBar({text: error.response.data.message, type: 'error'});
                    } else {
                        this.setSnackBar({text: 'Data Validation Failed', type: 'error'});
                    }
                })
                .finally(() => {
                    if (isLoaded) {
                        this.loadData();
                    } else {
                        this.hideLoading();
                    }
                    this.currentSelectedItem = null;
                });
        },
        async switchHandler({item, eventStatus}) {
            this.handleItem(this.actions.update, {...item, isActive: eventStatus, status: eventStatus});
        },
        async checkBoxHandler(item, eventStatus) {
            this.handleItem(this.actions.update, {...item, isNew: eventStatus});
        },
        handleSearch(searchTerm) {
            this.searchTerm = searchTerm

            this.loadData(true);
        },

        loadData(resetPaging = false) {
            let pagingData = this.getPagingData();
            if (resetPaging) {
                pagingData.page = 1;
            }

            pagingData.s = this.searchTerm || '';
            if (!_.isEmpty(pagingData.s)) {
                let queryLength = pagingData.s.length;
                if ((queryLength < this.searchLength) || (queryLength > this.searchLimit)) return;
            }

            if (this.isLoading || !this.actions.load) return;
            this.showLoading();
            this.$store
                .dispatch(this.actions.load, {...pagingData})
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.hideLoading()))
        },
        showLoading() {
            this.isLoading = true;
        },
        hideLoading() {
            this.isLoading = false;
        },
        handleActionButtonClick(data) {
            const actionButton = this.defaultActionButtons.find((button) => button.category === data.category);
            actionButton.clickHandler(data.row);
        },
        setSnackBar({text, type}) {
            this.$store.commit('SET_SNACKBAR', {text, type});
        },
        getItemStatus(status) {
            if (status === 1) {
                return 'Yes';
            }
            return 'No';
        },
        openSite(site) {
            window.open(`http://www.${site}`, '_blank');
        },
        getColor(status) {
            const _status = status.toLowerCase();

            if (_status === "completed") {
                return "#4CAF50";
            } else if (_status === "accepted") {
                return "#283593";
            } else if (_status === "rejected") {
                return "#FFC107";
            } else {
                return "#1565C0";
            }
        },
        getDate(date) {
            if (date) return moment(date).utc().format('MMM D,  YYYY');

            return '';
        },
        editInvoiceHandler(item) {
            this.$router.push({path: `/edit-invoice-migration/${item.id}`});
        },
        editMergedInvoiceHandler(item) {
            this.$router.push({path: `/edit-merged-invoice/${item.id}`});
        },
        manualPaymentHandler(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, {...item, paymentMethod: ''});
            this.showManualPaymentPopup = true;
        },
        manualMergedPaymentHandler(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, {...item, paymentMethod: ''});
            this.showManualMergedPaymentPopup = true;
        },
        copyTemplateHandler(item) {
            this.getMailTemplate(item);
        },
        async restoreHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showRestoreConfirm = true;
                return;
            }
            this.showRestoreConfirm = false;
            this.handleItem(this.actions.restore, item);
        },
        async refundInvoiceHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showRefundConfirm = true;
                return;
            }
            this.showRefundConfirm = false;
            this.handleItem(this.actions.refund, item);
        },
        async resendPaymentMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showResendMailConfirm = true;
                return;
            }
            this.showResendMailConfirm = false;

            this.handleItem(this.actions.paymentMailHandler, {id: item.id});
        },
        async resendMergedMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showMergedMailConfirm = true;
                return;
            }
            this.showMergedMailConfirm = false;
            this.handleItem(this.actions.resendMergedMailHandler, {id: item.id});
        },
        async updateMergedMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showMergedUpdateMailConfirm = true;
                return;
            }
            this.showMergedUpdateMailConfirm = false;
            this.handleItem(this.actions.updateMergedMailHandler, {id: item.id});
        },
        async reminderPaymentMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showReminderMailConfirm = true;
                return;
            }
            this.showReminderMailConfirm = false;

            await this.handleItem(this.actions.reminderMail, {id: item.id});
        },
        async afterReminderPaymentMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showAfterReminderMailConfirm = true;
                return;
            }
            this.showAfterReminderMailConfirm = false;

            await this.handleItem(this.actions.afterReminderMail, {id: item.id});
        },
        async republishedMailHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showRepublishMailConfirm = true;
                return;
            }
            this.showRepublishMailConfirm = false;

            this.handleItem(this.actions.republishedEmail, {id: item.id});
        },
        onResetInvoiceHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showResetInvoiceConfirm = true;
                return;
            }
            this.showResetInvoiceConfirm = false;
            this.handleItem(this.actions.reset, item);
        },
        onChangeDateHandler(range) {
            const {startDate, endDate} = range;

            this.startDate = startDate;
            this.endDate = endDate;
            this.loadData(true);
        },
        onChangeFilterHandler(selection, handler) {
            if (!selection) {
                this[handler] = '';
            }
            if (Object.keys(selection).length > 0) {
                this[handler] = selection.id;
            } else {
                this[handler] = selection;
            }
            this.loadData(true);
        },
        handleClearSearchResult() {
            this.searchEmail = '';
            this.loadData(true);
        },
        onSelections(selection) {
            this.searchEmail = selection.email;
            this.loadData(true);
        },
        async republishHandler(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showRepublishConfirm = true;
                return;
            }
            this.showRepublishConfirm = false;

            await this.handleItem(this.actions.republish, {id: item.id, billingType: item.billingType});
        },
        liveLinkReplacementHandler(item) {
            this.$router.push({path: `/live-link-replacement/${item.id}`});
        },
        siteOrderHandler(item) {
            this.handleItem(this.actions.update, {...item});
        },
        async onChangePaymentEmailHandler(tempType, confirm = false) {
            if (!tempType) {
                this.loadData(true);
                this.showMailConfirm = false;
                this.isNewsletterBtnLoading = false;
                return;
            }
            if (this.selected.length === 0 && !this.isSendMailToAll) {
                this.setSnackBar({text: 'No invoice are selected, Please select a invoice', type: 'info'});
                this.showMailConfirm = false;
                this.isNewsletterBtnLoading = false;
                return;
            }

            if (typeof tempType === 'object') {
                this.currentSelectedItem = tempType;
            } else {
                this.currentSelectedItem = this.mailTemplates.find((data) => data.id === tempType);
            }

            if (!confirm) {
                this.showMailConfirm = true;
                return;
            }

            this.showMailConfirm = false;

            const templateType = tempType.id;
            const selectedItems = this.selected.map((item) => item.id);
            this.selected = [];

            await this.handleItem(this.actions.sendMail, {
                selectedItems,
                templateType,
                mailer: this.mailer,
                isSendMailToAll: this.isSendMailToAll,
                mailType: this.param1,
                clientType: this.clientType
            });
        },
        getMethodNormalizedName(item) {
            if (!item) return '';
            return item.normalizedName;
        },
        async newsLetterHandler() {
            if (!this.$refs.mailBoxForm.validate()) {
                return;
            }

            this.isNewsletterBtnLoading = true;
            await this.onChangePaymentEmailHandler(this.templateType);
        },
        newsLetterTemplateHandler(selection) {
            if (selection) {
                this.templateType = selection;
            } else {
                this.templateType = null;
            }
        },
        async clearButtonHandler() {
            await this.handleItem(this.actions.clearData, {});
        },
        setGoogleSheetName(sheetType) {
            return sheetType === 'googleSheet' ? 'Reseller Sheet' : 'Site Sheet';
        },
        async syncItem(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showConfirm = true;
                return;
            }
            this.showConfirm = false;
            await this.handleItem(this.actions.syncItem, {id: item.id});
        },
        async syncItemMoz(item, confirm = false) {
            if (!confirm) {
                this.currentSelectedItem = item;
                this.showConfirmMoz = true;
                return;
            }
            this.showConfirmMoz = false;
            await this.handleItem(this.actions.syncItemMoz, {id: item.id});
        },
        getInvoiceTotal(item) {
            if (item.mergedInvoices) {
                return (Number.parseFloat(item.totalAmount) + Number.parseFloat(
                    item.mergedInvoices.reduce((prev, item) => {
                        return Number.parseFloat(prev + Number.parseFloat(item.merged_invoices.totalAmount));
                    }, 0)
                )).toFixed(2);
            } else {
                return Number(item.totalAmount).toFixed(2);
            }
        },
        getMergedTotal(item) {
            /*return Number.parseFloat(
                item.merged_invoice_details.reduce((prev, item) => {
                    return Number.parseFloat(prev + Number.parseFloat(item.invoice_details.totalAmount));
                }, 0)
            ).toFixed(2);*/

            return 0;
        }
    }
}